import { useContext } from 'react';

import LocaleContext, { LocaleContext as ILocaleContext } from './Locale.context';

export const useLocale = () => useContext(LocaleContext) as ILocaleContext;
